export default function ({ $axios }, inject) {
  // Create a custom axios instance
  const newAxios = $axios.create({
    baseURL: 'https://wox-drops.s3.amazonaws.com',
    headers: {
      common: {
        Accept: 'text/plain, */*'
      }
    }
  })

  // Inject to context as $api
  inject('axiosS3', newAxios)
}
